import { Injectable } from "@angular/core";
import {
    BaseNotificationEventsService,
    DssNotification,
    DssNotificationsService,
    DssTeamNotificationType,
} from "@dtm-frontend/dss-shared-lib";
import { Notification, NotificationDisplay, SharedNotificationDisplayProps } from "@dtm-frontend/shared/notifications";
import { IconName } from "@dtm-frontend/shared/ui";
import { FunctionUtils } from "@dtm-frontend/shared/utils";
import { TranslocoService } from "@jsverse/transloco";

@Injectable({
    providedIn: "root",
})
export class AnspTeamNotificationEventsService implements BaseNotificationEventsService {
    constructor(private readonly translocoService: TranslocoService, private readonly dssNotificationsService: DssNotificationsService) {}

    public getEventsList(notificationsToFormat: DssNotification[]): NotificationDisplay[] {
        return notificationsToFormat
            .filter((notification) =>
                this.dssNotificationsService.getDssTeamNotificationTypes().some((type) => notification.payload.type === type)
            )
            .map((notification) => {
                const sharedProps = this.getSharedProps(notification, "group");

                switch (notification.payload.type) {
                    case DssTeamNotificationType.AssignedTeamForRestrictionApplicationEvent:
                    case DssTeamNotificationType.AssignedAnotherTeamForRestrictionApplicationEvent:
                        return this.getAssignedTeamForRestrictionApplicationEvent(sharedProps, notification);

                    case DssTeamNotificationType.AssignedTeamForRestrictionModificationEvent:
                    case DssTeamNotificationType.AssignedAnotherTeamForRestrictionModificationApplicationEvent:
                        return this.getAssignedTeamForRestrictionModificationEvent(sharedProps, notification);

                    default:
                        return null;
                }
            })
            .filter(FunctionUtils.isTruthy);
    }

    private getAssignedTeamForRestrictionApplicationEvent(
        sharedProps: SharedNotificationDisplayProps,
        notification: DssNotification
    ): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.teamLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.assignedTeamText"),
            redirectUrl: `flight-zone/${notification.payload.id}`,
        };
    }

    private getAssignedTeamForRestrictionModificationEvent(
        sharedProps: SharedNotificationDisplayProps,
        notification: DssNotification
    ): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.teamLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.assignedTeamText"),
            redirectUrl: `modifications/${notification.payload.id}`,
        };
    }

    private getSharedProps(notification: Notification, icon: IconName): SharedNotificationDisplayProps {
        return { icon, date: notification.createdAt, id: notification.id, isRead: notification.read };
    }
}
